import { memo, useMemo } from 'react';
import { useTranslation } from '@hooks';
import ReviewsDistributionChart from './ReviewsDistributionChart';

const DAY_KEYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

const ReviewsByDay = memo(({ data, styles }) => {
    const { t } = useTranslation();

    const labels = DAY_KEYS.map(key => t(`AnalyticsReviews.${key}`));
    const legends = [t('AnalyticsReviews.positiveReviews'), t('AnalyticsReviews.negativeReviews')];

    const { positiveData, negativeData } = useMemo(() => {
        const positive = new Array(7).fill(0);
        const negative = new Array(7).fill(0);
        data.forEach(item => {
            positive[item.dayOfWeek] = item.averagePositiveReviews ?? 0;
            negative[item.dayOfWeek] = item.averageNegativeReviews ?? 0;
        });
        return { positiveData: positive, negativeData: negative };
    }, [data]);

    return (
        <ReviewsDistributionChart
            title={t('AnalyticsReviews.reviewsByDay')}
            labels={labels}
            positiveData={positiveData}
            negativeData={negativeData}
            legends={legends}
            chartId="reviews-by-day-chart-wrapper"
            styles={styles}
        />
    );
});

ReviewsByDay.displayName = 'ReviewsByDay';

export default ReviewsByDay;
